﻿import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Buttons.css';

export function TextButton(
    {
        id = null,
        loading = false,
        disabled = false,
        children,
        className,
        onClick
    }
) {

    return (
        <button
            className={classNames('btn-inline-text', { "bp6-skeleton": loading }, className)}
            onClick={onClick}
            disabled={disabled}
            id={id}
        >{children}</button>
    );
}

TextButton.propTypes = {
    id: PropTypes.string,
    loading: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired
};